// Is this account subscribed to Investor Outreach? (ATAI-271 · ATAI-260)
// Thin wrapper over the `investorOutreach` store slice: it dispatches the cached fetch (which reads
// the S2 cancel-preview once and reuses the result) and returns the stored state. Because the value
// is cached in Redux, the search route and the Account card no longer each re-call the API or
// re-show a loader on every visit — the same reason this used to own a per-mount fetch.
//   status: ACTIVE | UNSUBSCRIBED (pending cancellation) | null
//   endDate: set when a cancellation is pending
// `refetch` forces a fresh read (e.g. after Do Not Cancel).
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectUserId } from 'data/user';
import {
  fetchInvestorOutreachEntitlement,
  selectInvestorOutreachEntitled,
  selectInvestorOutreachEntitlementLoaded,
  selectInvestorOutreachEntitlementLoading,
  selectInvestorOutreachEntitlementError,
  selectInvestorOutreachStatus,
  selectInvestorOutreachEndDate,
  selectInvestorOutreachConnectCancelledWithIo,
  selectInvestorOutreachEndedDate,
} from 'data/investors';

export const useInvestorOutreachEntitlement = (enabled) => {
  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);

  const loaded = useSelector(selectInvestorOutreachEntitlementLoaded);
  const loading = useSelector(selectInvestorOutreachEntitlementLoading);
  const entitled = useSelector(selectInvestorOutreachEntitled);
  const error = useSelector(selectInvestorOutreachEntitlementError);
  const status = useSelector(selectInvestorOutreachStatus);
  const endDate = useSelector(selectInvestorOutreachEndDate);
  const connectCancelledWithIo = useSelector(selectInvestorOutreachConnectCancelledWithIo);
  const endedDate = useSelector(selectInvestorOutreachEndedDate);

  useEffect(() => {
    if (enabled && userId) {
      dispatch(fetchInvestorOutreachEntitlement(userId));
    }
  }, [enabled, userId, dispatch]);

  return {
    // `ready` keeps its old meaning — the fetch reached a known subscribed/not-subscribed answer.
    ready: Boolean(loaded) && !loading && !error,
    failed: Boolean(error),
    entitled: Boolean(entitled),
    status,
    endDate,
    connectCancelledWithIo: Boolean(connectCancelledWithIo),
    endedDate,
    refetch: () => dispatch(fetchInvestorOutreachEntitlement(userId, { force: true })),
  };
};
